var Reverb = window.Reverb || {};
Reverb.DashboardSelling = Reverb.DashboardSelling || {};

Reverb.DashboardSelling.ShippingLabels = (function () {
  function init() {
    addPhoneInputMask();
  }

  // US numbers only for the moment
  function addPhoneInputMask() {
    $('[data-shipping-label-phone-input]').inputmask('999-999-9999', { placeholder: ' ' });
  }

  return {
    init: init
  };
})();

$(Reverb.DashboardSelling.ShippingLabels.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dashboard/selling/shipping_labels.js